import { instance as axios } from "../../config/axiosInstance";

// ---------------------login----------------------------------
export const loginApi = async (data) => {
  return await axios.post("auth/login", data);
};
export const sendOtpApi = async (data) => {
  return await axios.post("auth/sendOto", data);
};
// ---------------------Verify Otp----------------------------------
export const verifyOtpApi = async (data) => {
  return await axios.post("auth/verify_otp", data);
};
// ---------------------Resend Otp----------------------------------
export const resendOtp = async (data) => {
  return await axios.post("auth/resend_otp", data);
};
// ---------------------forget-password------------------------------
export const forgetApi = async (data) => {
  return await axios.post(`auth/send-otp`, data);
};
// ---------------------reset-password---------------------------------
export const resetPasswordApi = async (data) => {
  const endPoint = "auth/reset-password";
  return await axios.post(endPoint, data);
};
